// extracted by mini-css-extract-plugin
export default {"header_box":"index_header_box_Ha-s2","header":"index_header_dIgZW clearfix"};